// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {buildRegistrationPayload} from '../../../product/shared/services/build-registration-payload';
import {getFileName} from '../../../shared/services/get-file-name';
import {getRegistrationResults} from '../../shared/repositories/index';
import {openFile} from '../../../shared/services/open-file';

export const exportToExcel = (accounts, language, layoutName, listId) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());
        const registrationPayload = buildRegistrationPayload(accounts, 'EXCEL', language, layoutName, listId);

        try {

            const response = await getRegistrationResults(registrationPayload);

            const fileName = getFileName(response);

            const blob = await response.blob();

            openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/registration-review/action-creators/export-to-excel.js